export const formConfig = {
  reporterTitlteMaxLength: 80,
  clientNameMaxLength: 70,
  textAreaMaxLength: 1500,
  sampleMaxLength: 9,
  fieldPeriodMaxLength: 70,
}

export const chartOrder = { 'GERAIS': 1, 'CRUZAMENTO_SIMPLES': 2, 'EVOLUTIVO': 3 };

export const Order = {
  ASC: 'ASC',
  DESC: 'DESC'
};

// Asset de marca: a key e um UUID de upload e pertence a Implantacao, entao a URL
// vem inteira da configuracao, e nao montada a partir da base.
export const DEFAULT_COVER_IMAGE =
  process.env.REACT_APP_DEFAULT_COVER_IMAGE_URL;

export const ALLOWED_FILE_TYPES = {
  PNG: "png",
  JPG: "jpg",
}
export const MAX_FILE_SIZE_BYTE = 5 * 1024 * 1024; // 5mb
export const MAX_FILE_SIZE_MB = 5;

export const IMAGE_LABEL = {
  UPLOAD_INSTRUCTION: `Suporta ${ALLOWED_FILE_TYPES.PNG.toUpperCase()} ou ${ALLOWED_FILE_TYPES.JPG.toUpperCase()}. Tamanho máximo: ${MAX_FILE_SIZE_MB} MB`,
  LOADING_MESSAGE: 'Salvando imagem...',
}
  
export const ERROR_FILE_MESSAGES = {
  SIZE_EXCEEDED: `O tamanho da imagem é superior a ${MAX_FILE_SIZE_MB}Mb. Por favor, selecione outra imagem e tente novamente.`,
  API_ERROR: 'Parece que ocorreu um erro ao carregar a imagem. Selecione outra imagem ou tente novamente mais tarde'
}

export const TIPOS_ERROS = {
  API_ERROR: "apiError",
  SIZE_EXCEEDED: "sizeExceeded",
}
